import { t } from 'ember-intl';
import { HdsTextBody } from '@hashicorp/design-system-components/components';
import { CoreModalConfirm } from 'core/components';
import { boxPadding } from 'core/modifiers';

const Delete = <template>
  <CoreModalConfirm
    @confirmHelp={{t "components.scim.tokens.delete.help"}}
    @confirmLabel={{t "components.scim.tokens.delete.label"}}
    @confirmText={{t "components.core.modal.confirm.delete"}}
    @headerIcon="alert-triangle"
    @headerText={{t
      "components.scim.tokens.delete.header"
      tokenName=@tokenToDelete.displayName
      htmlSafe=true
    }}
    @onCancel={{@onCancel}}
    @onSubmit={{@onSubmit}}
  >
    <:body>
      <HdsTextBody
        @tag="p"
        @color="primary"
        {{boxPadding "xs 0 lg 0"}}
        data-test-scim-tokens-delete-modal-content
      >
        {{t "components.scim.tokens.delete.description" htmlSafe=true}}
      </HdsTextBody>
    </:body>

  </CoreModalConfirm>
</template>;
export default Delete;
